import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledSectionHeader = styled.header`
  text-align: center;
  margin-bottom: ${themeGet('scale.scaleUp03')};

  sup {
    ${themeGet('font.whitneyMedium')}
    display: block;
    font-size: ${themeGet('scale.scaleDown01')};
    letter-spacing: 2px;
    color: ${themeGet('color.colorGrayBlue70')};
    text-transform: uppercase;
    margin-bottom: ${themeGet('scale.scaleBase')};
  }

  h2 {
    font-size: ${themeGet('scale.scaleUp04')};
    color: ${themeGet('color.colorGrayBlue900')};
    margin: 0;
  }

  p {
    margin-top: ${themeGet('scale.scaleBase')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    sup {
      margin-bottom: ${themeGet('scale.scaleUp03')};
    }

    h2 {
      font-size: ${themeGet('scale.scaleUp05')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: ${themeGet('scale.scaleUp07')};

    h2 {
      font-size: ${themeGet('scale.scaleUp07')};
    }
  }
`;

export default StyledSectionHeader;
